// opervex-frontend/src/Opervex/MaterialManagement/Stock.js

class Stock {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findByDeposit(product, deposit) {
    return this.#_api.get(`/MaterialManagement/StockSerial?product=${product}&deposit=${deposit}`);
  }

  async schema() {
    return [
      {
        key: "id",
        label: "Código",
        type: "number",
        visible: true,
        hidden: false,
      },
      {
        key: "description",
        label: "Descrição",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "unitMeasurement",
        label: "Unidade",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "externalCode",
        label: "Código Externo",
        type: "string",
        visible: true,
        hidden: false,
      },
      {
        key: "disabled",
        label: "Inativo",
        type: "boolean",
        visible: true,
        hidden: true,
      },
      {
        key: "depositId",
        label: "Código Depósito",
        type: "number",
        visible: true,
        hidden: true,
      },
    ];
  }
}

export default Stock;
